import React from 'react';
import MaterialFlatButton from 'material-ui/FlatButton';
import classNames from 'classnames';
import './Button.styl';

export default class FlatButton extends React.PureComponent {
  render() {
    return (
      <MaterialFlatButton
        {...this.props}
        className={classNames(this.props.className, 'ev-button')}
      />
    );
  }
}
